import { AbstractGlobalProvider } from './provider.js';
export var AdError;
(function (AdError) {
    AdError["Unfilled"] = "unfilled";
})(AdError || (AdError = {}));
class Ads extends AbstractGlobalProvider {
    name = 'uber-ad-provider';
    hasAd() {
        for (const p of this.providers) {
            if (p.hasAd())
                return true;
        }
        return false;
    }
    showRewardedAd(userGesture) {
        for (const p of this.providers) {
            if (p.hasAd())
                return p.showRewardedAd(userGesture);
        }
        return Promise.reject({ status: 'ads-unavailable', provider: this });
    }
}
export const ads = new Ads();
